// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_im-0";
export var fileCarousel = "_im-2";
export var removeFileButton = "_im-1";